module.exports = __webpack_public_path__ + "img/logo-muven.96e5734f.png";